import { render, staticRenderFns } from "./RemoteList.vue?vue&type=template&id=5a522780&scoped=true&"
import script from "./RemoteList.vue?vue&type=script&lang=js&"
export * from "./RemoteList.vue?vue&type=script&lang=js&"
import style0 from "./RemoteList.vue?vue&type=style&index=0&id=5a522780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a522780",
  null
  
)

export default component.exports